(function () {
  if (window.sondosCartPromoInitialized) return;
  window.sondosCartPromoInitialized = true;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  // Wave 1 / F-01: one money shape store-wide — NIS before the number, no
  // trailing .00. Mirrors snippets/sondos-money.liquid and the routine builder.
  // The shop's own format string is ignored on purpose; it produced "72.00 ILS"
  // here while cards showed "NIS 68".
  function formatMoney(cents) {
    var n = Number(cents) / 100;
    if (!isFinite(n)) n = 0;
    var negative = n < 0;
    var rounded = Math.round(Math.abs(n) * 100) / 100;
    var body = rounded % 1 === 0 ? String(Math.round(rounded)) : rounded.toFixed(2);
    var parts = body.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (negative ? '-' : '') + 'NIS ' + parts.join('.');
  }

  function discountApplications(cart) {
    var applications = [];

    (cart.cart_level_discount_applications || []).forEach(function (application) {
      applications.push({
        application: application,
        amount: Number(application.total_allocated_amount) || 0
      });
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        applications.push({
          application: allocation.discount_application || {},
          amount: Number(allocation.amount) || 0
        });
      });
    });

    return applications;
  }

  function applicationMatches(application, code) {
    var target = normalize(code);
    return normalize(application.code) === target || normalize(application.title) === target;
  }

  function hasDiscount(cart, code) {
    var target = normalize(code);
    var codes = Array.isArray(cart.discount_codes)
      ? cart.discount_codes
      : (cart.discount_codes ? [cart.discount_codes] : []);

    return codes.some(function (discount) {
      return normalize(discount.code || discount.title) === target && discount.applicable !== false;
    }) || discountApplications(cart).some(function (entry) {
      return applicationMatches(entry.application, code);
    });
  }

  function savingsForCode(cart, code) {
    return discountApplications(cart).reduce(function (total, entry) {
      return applicationMatches(entry.application, code) ? total + entry.amount : total;
    }, 0);
  }

  function setStatus(container, message, isError) {
    var status = container.querySelector('[data-sondos-cart-promo-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function addedItemFromCart(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;

    var notify = document.querySelector('cart-notification');
    var key = (notify && (notify.cartItemKey || notify.dataset.cartItemKey)) || '';

    if (!key) {
      var host = document.getElementById('cart-notification-product');
      var node = host && host.querySelector('[id^="cart-notification-product-"]');
      if (node && node.id) key = node.id.replace('cart-notification-product-', '');
    }

    if (key) {
      var byKey = cart.items.find(function (item) { return item.key === key; });
      if (byKey) return byKey;
    }

    var variantId = notify && Number(notify.dataset.variantId || notify.dataset.productId);
    if (variantId) {
      var matches = cart.items.filter(function (item) {
        return Number(item.variant_id || item.id) === variantId;
      });
      if (matches.length) return matches[matches.length - 1];
    }

    return null;
  }

  function notificationVisibleItems(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return [];

    var host = document.getElementById('cart-notification-product');
    var keys = [];

    if (host) {
      keys = Array.from(host.querySelectorAll('[id^="cart-notification-product-"]'))
        .map(function (node) {
          return node.id.replace('cart-notification-product-', '');
        })
        .filter(Boolean);
    }

    if (!keys.length) {
      var notify = document.querySelector('cart-notification');
      var raw = notify && notify.dataset.addedItemKeys;
      if (raw) {
        keys = raw.split(',').map(function (part) { return part.trim(); }).filter(Boolean);
      }
    }

    if (keys.length) {
      var matched = keys.map(function (key) {
        return cart.items.find(function (item) { return item.key === key; });
      }).filter(Boolean);
      // Applying a discount can reshuffle line keys; fall through rather than show
      // "activated" with an empty price row.
      if (matched.length) return matched;
    }

    var one = addedItemFromCart(cart);
    if (one) return [one];

    // Last resort: the line Shopify just appended.
    return [cart.items[cart.items.length - 1]];
  }

  /**
   * The quantity the card above is showing, which is the whole line rather than the
   * amount just added. Adding one unit to a line that already held two must discount
   * all three, otherwise the promo contradicts the line total printed on the card.
   */
  function notificationQuantity(item) {
    var host = document.getElementById('cart-notification-product');
    var node = host && item && item.key
      ? host.querySelector('[id="cart-notification-product-' + item.key + '"]')
      : null;
    var fromCard = node ? Number(node.dataset.quantity) : 0;

    if (fromCard > 0) return fromCard;
    return Math.max(1, Number(item && item.quantity) || 1);
  }

  function promoPercent(container) {
    var raw = container && container.dataset ? container.dataset.percent : '';
    var parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 && parsed < 100 ? parsed : 0;
  }

  function pricesForNotificationItem(container, item, qty) {
    var percent = promoPercent(container);
    var unitBefore = Number(item.original_price) || 0;
    var unitAfter = Number(item.final_price) || 0;
    var lineBefore = Number(item.original_line_price) || 0;
    var lineAfter = Number(item.final_line_price) || 0;
    var lineQty = Math.max(1, Number(item.quantity) || 1);

    if (lineBefore > lineAfter && lineQty === qty) {
      return { before: lineBefore, after: lineAfter };
    }

    if (unitBefore > unitAfter && unitAfter > 0) {
      return { before: unitBefore * qty, after: unitAfter * qty };
    }

    var baseUnit = unitAfter || unitBefore || Math.round(lineAfter / lineQty) || 0;
    if (baseUnit > 0 && percent > 0) {
      return {
        before: baseUnit * qty,
        after: Math.round(baseUnit * (100 - percent) / 100) * qty
      };
    }

    return null;
  }

  function notificationProductPrices(container, cart) {
    var items = notificationVisibleItems(cart);
    if (!items.length) return null;

    var before = 0;
    var after = 0;
    var matched = 0;

    items.forEach(function (item) {
      var qty = notificationQuantity(item);
      var prices = pricesForNotificationItem(container, item, qty);
      if (!prices) return;
      before += prices.before;
      after += prices.after;
      matched += 1;
    });

    if (!matched) return null;
    return { before: before, after: after };
  }

  /**
   * Picks the before/after pair shown under "تم تفعيل الخصم".
   *
   * The first open after a fresh discount code is the fragile case: Shopify has accepted
   * the code on the cart, but line prices often still read as full price (cart-level
   * allocation) and line keys can reshuffle. Falling through product → snapshot →
   * cart-level saving → percent keeps the row from rendering empty.
   */
  function notificationRevealPrices(container, cart, snapshot) {
    var productPrices = notificationProductPrices(container, cart);
    if (productPrices && productPrices.before > productPrices.after) {
      return productPrices;
    }

    if (
      snapshot &&
      Number(snapshot.before) > Number(snapshot.after) &&
      (!snapshot.code || normalize(snapshot.code) === normalize(container.dataset.code))
    ) {
      return {
        before: Number(snapshot.before),
        after: Number(snapshot.after)
      };
    }

    var items = notificationVisibleItems(cart);
    var lineSum = items.reduce(function (total, item) {
      return total + (Number(item.final_line_price) || Number(item.original_line_price) || 0);
    }, 0);
    var codeSaved = savingsForCode(cart, container.dataset.code);
    if (codeSaved > 0 && lineSum > 0) {
      return {
        before: lineSum,
        after: Math.max(0, lineSum - Math.min(codeSaved, lineSum))
      };
    }

    var percent = promoPercent(container);
    if (lineSum > 0 && percent > 0) {
      return {
        before: lineSum,
        after: Math.round(lineSum * (100 - percent) / 100)
      };
    }

    return productPrices && productPrices.before > 0 ? productPrices : null;
  }

  function optimisticNotificationSnapshot(container, cart) {
    var prices = notificationRevealPrices(container, cart, null);
    if (!prices || prices.before <= prices.after) return null;
    return {
      code: container.dataset.code,
      before: prices.before,
      after: prices.after,
      saved: prices.before - prices.after,
      optimistic: true
    };
  }

  function renderApplied(container, cart, snapshot) {
    var isNotification = container.dataset.sondosCartPromoScope === 'notification';
    var idle = container.querySelector('[data-sondos-cart-promo-idle]');
    var done = container.querySelector('[data-sondos-cart-promo-done]');
    var reveal = container.querySelector('[data-sondos-cart-promo-reveal]');
    var savedLine = container.querySelector('[data-sondos-cart-promo-saved-line]');
    var beforeElement = container.querySelector('[data-sondos-cart-promo-before]');
    var afterElement = container.querySelector('[data-sondos-cart-promo-after]');
    var savedElement = container.querySelector('[data-sondos-cart-promo-saved]');
    var before;
    var after;
    var saved;

    container.classList.add('is-applied');
    if (idle) idle.hidden = true;
    if (done) done.hidden = false;

    if (isNotification) {
      var productPrices = notificationRevealPrices(container, cart, snapshot);
      if (productPrices && productPrices.before > productPrices.after) {
        before = productPrices.before;
        after = productPrices.after;
        saved = before - after;
        if (afterElement) afterElement.textContent = formatMoney(after);
        if (beforeElement) beforeElement.textContent = formatMoney(before);
        if (reveal) reveal.hidden = false;
      } else if (reveal) {
        reveal.hidden = true;
      }
      if (savedLine) savedLine.hidden = true;
      setStatus(container, '', false);
      return;
    }

    after = Number(cart.total_price) || 0;
    saved = savingsForCode(cart, container.dataset.code);
    var originalTotal = Number(cart.original_total_price) || 0;
    var percent = promoPercent(container);
    var snapshotMatches = snapshot &&
      normalize(snapshot.code) === normalize(container.dataset.code) &&
      (snapshot.optimistic || Number(snapshot.after) === after);
    if (!saved && snapshotMatches) saved = Number(snapshot.saved) || 0;

    if (snapshotMatches && snapshot.optimistic) {
      before = Number(snapshot.before) || after;
      after = Number(snapshot.after) || after;
      saved = Number(snapshot.saved) || Math.max(0, before - after);
    } else if (saved > 0) {
      before = after + saved;
    } else if (originalTotal > after) {
      before = originalTotal;
      saved = originalTotal - after;
    } else if (percent > 0 && after > 0) {
      before = Math.round(after * 100 / (100 - percent));
      saved = Math.max(0, before - after);
    } else {
      before = after;
      saved = 0;
    }

    if (afterElement) afterElement.textContent = formatMoney(after);

    if (saved > 0) {
      if (beforeElement) beforeElement.textContent = formatMoney(before);
      if (reveal) reveal.hidden = false;
    } else {
      if (reveal) reveal.hidden = true;
    }

    if (savedLine) savedLine.hidden = true;
    setStatus(container, '', false);
  }

  function renderIdle(container, message, isError) {
    var idle = container.querySelector('[data-sondos-cart-promo-idle]');
    var done = container.querySelector('[data-sondos-cart-promo-done]');
    var button = container.querySelector('[data-sondos-cart-promo-apply]');

    container.classList.remove('is-applied');
    if (idle) idle.hidden = false;
    if (done) done.hidden = true;
    if (button) {
      button.disabled = false;
      button.textContent = 'طبّقي العرض';
    }
    setStatus(container, message, isError);
  }

  function syncPromo(container, cart, snapshot) {
    var code = container.dataset.code;
    if (!code) return;
    if (hasDiscount(cart, code)) {
      renderApplied(container, cart, snapshot);
      return;
    }

    // Notification: never show the manual "apply" UI — keep the applied design.
    if (container.dataset.sondosCartPromoScope === 'notification') {
      renderApplied(container, cart, snapshot || optimisticNotificationSnapshot(container, cart));
      return;
    }

    // Cart: show applied total design (optimistic) instead of the apply button.
    var percent = promoPercent(container);
    var total = Number(cart.total_price) || 0;
    var estimatedAfter = percent > 0
      ? Math.round(total * (100 - percent) / 100)
      : total;
    renderApplied(container, cart, {
      code: code,
      before: total,
      after: estimatedAfter,
      saved: Math.max(0, total - estimatedAfter),
      optimistic: true
    });
  }

  function syncAllPromos(cart, snapshot) {
    document.querySelectorAll('[data-sondos-cart-promo]').forEach(function (container) {
      syncPromo(container, cart, snapshot);
    });
  }

  function sectionRequests() {
    var requests = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    if (items && items.dataset.id) {
      requests.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    }
    if (footer && footer.dataset.id) {
      requests.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      requests.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }

    return requests;
  }

  function sectionInnerHTML(html, selector) {
    var documentFragment = new DOMParser().parseFromString(html, 'text/html');
    var selected = documentFragment.querySelector(selector);
    return selected ? selected.innerHTML : '';
  }

  function renderSections(cart, requests) {
    if (!cart.sections) return;

    requests.forEach(function (request) {
      var root = document.getElementById(request.id);
      var html = cart.sections[request.section];
      if (!root || !html) return;
      var target = root.querySelector(request.selector) || root;
      target.innerHTML = sectionInnerHTML(html, request.selector);
    });
  }

  function refreshPromoState(showError) {
    return fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(syncAllPromos)
      .catch(function () {
        if (!showError) return;
        document.querySelectorAll('[data-sondos-cart-promo]').forEach(function (container) {
          renderIdle(container, 'تعذّر التحقق من العرض. حاولي مرة أخرى.', true);
        });
      });
  }

  /**
   * Shopify bot protection scores repeated discount writes as code probing, and answers
   * with the Cloudflare "verify you are human" wall on /cart. So an automatic apply is
   * attempted at most once per cart state (token + item count): a code that does not
   * stick never retries on the next page view, but a cart that actually changed does.
   * Manual taps on "طبّقي العرض" are never throttled.
   */
  function autoApplyKey(cart, code) {
    return 'snd_promo_auto:' + normalize(code) + ':' + (cart.token || '') + ':' + (cart.item_count || 0);
  }

  function autoApplyAttempted(cart, code) {
    try {
      return window.sessionStorage.getItem(autoApplyKey(cart, code)) === '1';
    } catch (e) {
      return false;
    }
  }

  function markAutoApplyAttempted(cart, code) {
    try {
      window.sessionStorage.setItem(autoApplyKey(cart, code), '1');
    } catch (e) { /* private mode / quota */ }
  }

  function applyDiscountCode(code, requests, knownCart) {
    return Promise.resolve(knownCart || fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      }))
      .then(function (beforeCart) {
        var payload = { discount: code };
        if (requests.length) {
          payload.sections = requests.map(function (request) { return request.section; });
          payload.sections_url = window.location.pathname;
        }

        return fetch(shopRoot() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) throw new Error('Discount request failed');
          return response.json();
        }).then(function (cart) {
          return { beforeCart: beforeCart, cart: cart };
        });
      })
      .then(function (result) {
        var cart = result.cart;
        var before = Number(result.beforeCart.total_price) || 0;
        var after = Number(cart.total_price) || 0;
        return {
          cart: cart,
          snapshot: {
            code: code,
            before: before,
            after: after,
            saved: Math.max(0, before - after)
          }
        };
      });
  }

  function applyPromo(button) {
    var container = button.closest('[data-sondos-cart-promo]');
    var code = container && container.dataset.code;
    if (!container || !code || button.disabled) return;

    var requests = sectionRequests();

    document.querySelectorAll('[data-sondos-cart-promo-apply]').forEach(function (applyButton) {
      applyButton.disabled = true;
    });
    button.textContent = 'جاري التطبيق…';
    setStatus(container, 'نراجع أهلية السلة للعرض…', false);

    applyDiscountCode(code, requests)
      .then(function (result) {
        var cart = result.cart;
        if (!hasDiscount(cart, code)) throw new Error('Discount is not applicable');
        renderSections(cart, requests);
        syncAllPromos(cart, result.snapshot);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, source: 'sondos-cart-promo' }
        }));
      })
      .catch(function () {
        document.querySelectorAll('[data-sondos-cart-promo]').forEach(function (promo) {
          renderIdle(promo, 'لم ينطبق العرض على هذه السلة. راجعي الشروط أو حاولي لاحقاً.', true);
        });
      });
  }

  var autoApplyingNotification = false;
  var autoApplyingCart = false;
  var navigatingToCart = false;
  var notificationApplyController = null;

  function cartPromoContainers() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-sondos-cart-promo][data-sondos-cart-promo-scope="cart"]')
    );
  }

  function ensureCartPromo() {
    var containers = cartPromoContainers();
    if (!containers.length || autoApplyingCart) return;

    var code = containers[0].dataset.code;
    if (!code) return;

    fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart.item_count) {
          containers.forEach(function (container) {
            syncPromo(container, cart);
          });
          return null;
        }

        if (hasDiscount(cart, code)) {
          containers.forEach(function (container) {
            syncPromo(container, cart);
          });
          return null;
        }

        containers.forEach(function (container) {
          syncPromo(container, cart);
        });

        if (autoApplyAttempted(cart, code)) return null;
        markAutoApplyAttempted(cart, code);
        autoApplyingCart = true;

        return applyDiscountCode(code, sectionRequests(), cart).then(function (result) {
          if (!hasDiscount(result.cart, code)) throw new Error('Discount is not applicable');
          renderSections(result.cart, sectionRequests());
          syncAllPromos(result.cart, result.snapshot);
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: result.cart, source: 'sondos-cart-promo' }
          }));
        });
      })
      .catch(function () { /* silent */ })
      .finally(function () {
        autoApplyingCart = false;
      });
  }

  function ensureNotificationPromo() {
    var container = document.querySelector('cart-notification [data-sondos-cart-promo]');
    if (!container || autoApplyingNotification) return;
    if (navigatingToCart) return;

    var code = container.dataset.code;
    if (!code) return;

    if (notificationApplyController) {
      notificationApplyController.abort();
    }
    notificationApplyController = typeof AbortController !== 'undefined'
      ? new AbortController()
      : null;

    fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: notificationApplyController ? notificationApplyController.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        if (navigatingToCart) return null;
        if (hasDiscount(cart, code)) {
          syncPromo(container, cart);
          return null;
        }

        // Show the applied design immediately (with estimated prices), then apply
        // the code in the background. Passing the snapshot here is what keeps the
        // before/after row from staying blank on the very first activation.
        renderApplied(container, cart, optimisticNotificationSnapshot(container, cart));
        if (navigatingToCart) return null;
        if (autoApplyAttempted(cart, code)) return null;
        markAutoApplyAttempted(cart, code);
        autoApplyingNotification = true;
        return applyDiscountCode(code, sectionRequests(), cart).then(function (result) {
          if (navigatingToCart) return null;
          if (!hasDiscount(result.cart, code)) throw new Error('Discount is not applicable');
          renderSections(result.cart, sectionRequests());
          syncPromo(container, result.cart, result.snapshot);
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: result.cart, source: 'sondos-cart-promo' }
          }));
        });
      })
      .catch(function () {
        /* keep silent in notification — cart page still has manual apply */
      })
      .finally(function () {
        autoApplyingNotification = false;
        notificationApplyController = null;
      });
  }

  document.addEventListener('click', function (event) {
    var viewCartButton = event.target.closest('#cart-notification-button');
    if (viewCartButton) {
      navigatingToCart = true;
      if (notificationApplyController) notificationApplyController.abort();
      return;
    }

    var button = event.target.closest('[data-sondos-cart-promo-apply]');
    if (!button) return;
    event.preventDefault();
    applyPromo(button);
  });

  document.addEventListener('cart:notification-open', function () {
    navigatingToCart = false;
    ensureNotificationPromo();
  });

  document.addEventListener('cart:drawer-open', function () {
    ensureCartPromo();
  });

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.source === 'sondos-cart-promo') return;

    // Quantity add/remove on /cart sends a partial cart payload — refresh from cart.js.
    if (event.detail && event.detail.source === 'cart-items') {
      refreshPromoState(false);
      return;
    }

    if (event.detail && event.detail.cart) {
      syncAllPromos(event.detail.cart);
      return;
    }
    refreshPromoState(false);
  });

  // ensureCartPromo already fetches cart.js and syncs every cart-scope container, and it
  // no-ops when the page has none. Calling refreshPromoState here too meant a second
  // GET /cart.js on every page view of the whole storefront, for nothing.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureCartPromo, { once: true });
  } else {
    ensureCartPromo();
  }
})();
